<template>
  <div class="text-sm-left">
    <span v-if="debug === 'true' || debug === true">{{version}}</span>

    <b-row class="mt-4">
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="Nombre(s)"> Nombre(s): </label>
        <b-form-input
            v-model="persona.nombre"
            placeholder="Ingrese su(s) nombre(s)"
            disabled
        >
        </b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="Apellido paterno"> Apellido Paterno: </label>
        <b-form-input
            v-model="persona.apellidoPaterno"
            placeholder=" Ingrese su Apellido paterno:"
            disabled
        >
        </b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="Apellido materno"> Apellido materno: </label>
        <b-form-input
            v-model="persona.apellidoMaterno"
            placeholder="Ingrese su Apellido materno:"
            disabled
        >
        </b-form-input>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="Fecha nacimiento"> Fecha de nacimiento: </label>
        <b-form-input
            v-model="persona.fechaNacimiento"
            placeholder="Ingrese su Fecha nacimiento:"
            disabled
        ></b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="sobrenombre"> ¿Como te gusta que te llamen?: </label>
        <b-form-input
            v-model="persona.sobrenombre"
            placeholder="¿Como te gusta que te llamen?"
        ></b-form-input>
      </b-col>

      <b-col sm="12" md="6" lg="4" xl="4">
        <label for="sexo"> Sexo: </label>
        <v-select
            style="width: 100%;"
            label="nombre"
            id="sexoComp"
            :options="listaSexo"
            :reduce="(val) => val.nombre"
            v-model="persona.sexo"
            placeholder="Selecciona un sexo"
        ></v-select>
      </b-col>
    </b-row>

    <b-row class="mt-4">
      <b-col sm="12" md="6" lg="4" xl="4" v-if="cargandoPlanes">
        <b-spinner variant="primary" label="Text Centered"></b-spinner>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4" v-else>
        <label for="plan"> Plan: </label>
        <b-form-input
            v-model="persona.nombrePlan"
            placeholder="Plan"
            :disabled="persona.idPlan !== null"
            v-if="persona.idPlan !== null"
        ></b-form-input>

        <b-form-input
            v-model="nombrePlan"
            placeholder="Paciente sin plan(es)"
            disabled
            v-else
        ></b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <br/>
        <b-form-radio-group
            v-model="persona.planTitularBeneficiario"
            :options="optionsPlan"
            :aria-describedby="ariaDescribedby"
            :disabled="idPlan == null && persona.idPlan == null   "
            name="radio-inline"
        ></b-form-radio-group>

      </b-col>

      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Correo:</label>
        <b-form-input
            type="email"
            v-model="persona.correo"
            placeholder="Correo:"
        >
        </b-form-input>
      </b-col>
    </b-row>


    <b-row class="mt-4">

      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Teléfono celular:</label>
        <b-form-input
            v-model="persona.telefono"
            placeholder="Teléfono:"
            type="tel"
        >
        </b-form-input>
      </b-col>

      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Empresa en la que trabaja:</label>
        <b-form-input
            v-model="persona.empresaTrabajo"
            placeholder="empresa"
            type="text"
        >
        </b-form-input>
      </b-col>
      <b-col sm="12" md="6" lg="4" xl="4">
        <label>Puesto que desempeña:</label>
        <b-form-input
            v-model="persona.puestoDesempenio"
            placeholder="puesto"
        >
        </b-form-input>
      </b-col>
    </b-row>
  </div>
</template>

<script>

export default {
  name: "DatosPacienteHC",
  props:{
    persona: Object,
    listaEnterarse: Array,
    listaSexo: Array,
    cargandoPlanes: Boolean,
    cargandoCercania: Boolean,
    cargandoConfianza: Boolean,
    cargandoMedio: Boolean,

  },
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,

    nombrePlan: "",
    idPlan: null,
    optionsPlan: [
      { text: 'Titular', value: 1 },
      { text: 'Beneficiario', value: 2 },
    ]
  }),
  created() {
    this.debug = this.$localStorageService.getDebug();
  }
}
</script>

<style scoped>
label{
  color: #0046A2 !important;
}
</style>